let history;
const getHistory = () => history;
export const setHistory = providedHistory => {
  history = providedHistory;
};
export default getHistory;